import { Text } from '@repo/foundations';
import { useMemo } from 'react';
import { formatRelativeTime } from '../../../utils/time';
import type { INotificationTitleProps } from '../types';

export function NotificationTime({ notification }: INotificationTitleProps) {
	const relativeTime = useMemo(
		() => formatRelativeTime(notification.updated_at),
		[notification.updated_at]
	);

	return (
		<Text
			sx={{
				marginRight: '2px',
			}}
			size="xs"
			color="text/secondary/default"
			lineClamp={1}
		>
			{relativeTime}
		</Text>
	);
}
